import { Component, Input } from "@angular/core";
import { EColumnType } from "../table/EColumnType";

@Component({
  selector: "ngx-info-lote-importacao",
  templateUrl: "./info-lote.component.html",
  styleUrls: ["./info-lote.component.scss"],
})
export class InfoLoteImportacaoComponent {
  @Input() data: Array<{ title: string; value?: any; type: EColumnType }> = [];
  @Input() enumMap: any;
  @Input() enum: any;

  EColumnType = EColumnType;

  addOpacityToColor(hexColor: string, opacity: number): string {
    // Remove o '#' do hexColor, se existir
    const hex = hexColor.replace("#", "");

    // Converte o hexadecimal para RGB
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Retorna a cor em formato rgba
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  getColumnWidth() {
    if (this.data.length % 5 === 0) {
      return '20%';
    } else {
      return '25%';
    }
  }
}
